import React from 'react';
import Header from './Header';
import Footer from './Footer';
import CookieConsent from './CookieConsent';

export default function Layout({ children }) {
  return (
    <div className="yk-app">
      <Header />
      <main className="yk-main">
        <div className="yk-container">{children}</div>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
